"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.string.starts-with");
var _decorate = require("@/api/zdyPage/decorate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'floatingButtonStyle',
  props: {
    datas: Object,
    title: String
  },
  data: function data() {
    return {
      resPath: process.env.VUE_APP_IMAGE_PATH,
      predefineColors: ['#ff4500', '#ff8c00', '#ffd700', '#90ee90', '#00ced1', '#1e90ff', '#c71585', '#409EFF', '#909399', '#C0C4CC', '#155bd4', '#ff5777', '#21bf4b', '#fe7e3e', 'rgba(255, 69, 0, 0.68)', 'rgba(24, 144, 255, 1)']
    };
  },
  created: function created() {
    // 老数据可能没有这些字段，补上以保证响应式
    if (this.datas) {
      if (this.datas.backgroundImg === undefined) {
        this.$set(this.datas, 'backgroundImg', '');
      }
      if (this.datas.bgWidth === undefined) {
        this.$set(this.datas, 'bgWidth', 0);
      }
      if (this.datas.bgHeight === undefined) {
        this.$set(this.datas, 'bgHeight', 0);
      }
      if (this.datas.bgColor === undefined) {
        this.$set(this.datas, 'bgColor', '');
      }
    }
  },
  methods: {
    handleImageClick: function handleImageClick() {
      // 未上传时才触发文件选择；已有图时通过删除按钮操作
      if (this.datas.backgroundImg) return;
      var fileInput = this.$refs.bgFileInput;
      if (fileInput) fileInput.click();
    },
    handleRemoveFile: function handleRemoveFile() {
      this.$set(this.datas, 'backgroundImg', '');
      // 重置 input value，便于再次选择同一文件
      if (this.$refs.bgFileInput) this.$refs.bgFileInput.value = '';
    },
    handleFileChange: function handleFileChange(event) {
      var _this = this;
      var file = event.target.files[0];
      if (!file) return;
      var isImage = file.type.startsWith('image/');
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isImage) {
        this.$message.error('只能上传图片文件');
        return;
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB');
        return;
      }
      var formData = new FormData();
      formData.append('file', file);
      (0, _decorate.uploadImg)(formData).then(function (res) {
        if (res.code === 200) {
          var imgPath = res.data && res.data.pathKey ? res.data.pathKey : res.data;
          _this.$set(_this.datas, 'backgroundImg', imgPath);
          _this.$message.success('上传成功');
        } else {
          _this.$message.error(res.message || '上传失败');
        }
      }).catch(function () {
        _this.$message.error('上传失败');
      });

      // 清空 input value，便于再次选择同一文件
      event.target.value = '';
    }
  }
};